/* eslint-disable @typescript-eslint/no-explicit-any */
import PhIcon from '@mercadoni/sinister/dist/cjs/PhIcon'
import { Menu } from 'antd'
import styled from 'styled-components'
import Link from './Link'
import Text from './Text'

const StyledMenuDropdown = styled(Menu)`
  &.ant-dropdown-menu {
    font-size: var(--app-subheader-fontsize-s2, --typography-size-s2);
    padding: 0;
    min-width: 150px;

    .ant-dropdown-menu-submenu-title {
      display: flex;
      align-items: center;
    }
  }
`

const MenuDropdownLogic = ({
  Wrapper,
  items = [],
}: {
  Wrapper: any
  items: any[]
}) => {
  const getMenuItem = (item: any) => {
    const { name, link, key, children } = item

    if (children?.length) {
      const parsedChildren = children.map((child: any) => getMenuItem(child))
      return {
        key,
        label: <Text text={name} />,
        children: parsedChildren,
      }
    }

    return {
      key,
      label: <Link text={name} {...link} />,
    }
  }

  const menuItems = items.map((item) => getMenuItem(item))
  return (
    <Wrapper
      items={menuItems}
      expandIcon={<PhIcon className="ph-caret-right" />}
    />
  )
}

const MenuDropdown = ({ items }: { items: any[] }) => (
  <MenuDropdownLogic Wrapper={StyledMenuDropdown} items={items} />
)

export default MenuDropdown
